var $f128a549f8c2b170$exports = {};
$f128a549f8c2b170$exports = {
    "loading": `Ladataan\u{2026}`,
    "placeholder": `Valitse\u{2026}`
};


export {$f128a549f8c2b170$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
